import { AppraisalReviewExternalService } from "../services/appraisalReviewIExternalService";
import { LogInternalService } from "../services/logInternalService";
import { AppraisalReviewStore } from "./appraisalReviewStore";

export class AppraisalReviewExternalStore extends AppraisalReviewStore {
  constructor(globalStore) {
    super(globalStore);
    this.appraisalReviewService = new AppraisalReviewExternalService();
    this.logService = new LogInternalService();
  }
}
